export default __webpack_public_path__ + "static/media/ux.e1833ec6.svg";